var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 67,
    viewBox: "0 0 46 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5C39",
    fillRule: "evenodd",
    d: "M23 22c-3.865 0-7-3.134-7-7s3.135-7 7-7c3.866 0 7 3.134 7 7s-3.134 7-7 7M6.885 39.957l14.96 26.126c.258.558.833.917 1.467.917.64 0 1.22-.367 1.475-.934l18.405-33.202c.712-1.287 1.33-2.625 1.773-4.019 2.758-8.686-.068-18.33-7.606-24.064C33.45 1.806 28.495 0 22.998 0 17.483 0 12.516 1.817 8.602 4.807 1.253 10.42-1.59 19.747.862 28.258c.488 1.696 1.224 3.317 2.106 4.858l3.917 6.84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.68dce9ac.svg";
export { ForwardRef as ReactComponent };